export enum Adaptability { 
    HighAdaptability = 1,
    LowAdaptability = 3
    }